export const tabTheme = {
    baseStyle: {
        fontFamily: 'fonts',
    },
}
